export const MODAL_SETTINGS = "MODAL_SETTINGS";
export const MODAL_OBJECT_INFO = "MODAL_OBJECT_INFO";
